export enum CalendarTabs {
  availability = 'availability',
  calendarSettings = 'calendarSettings',
  bookAppointment = 'bookAppointment',
}
